import React from 'react';
import { ChartZone, MgpGaugeChart } from '../../components/MgpGaugeChart/MgpGaugeChart';
import { SummaryChartLoading } from './SummaryChartLoading';
import {
  StyledSummaryChart,
  SummaryChartTitle,
  SummaryChartStats,
  SummaryChartStat,
  SummaryChartStatLabel,
  SummaryChartStatValue,
  SummaryChartRange,
} from './SummaryChartStyles';

export interface SummaryChartData {
  value: number;
  avgReturn: string;
  badTiming: string;
  targetZone: {
    color: string;
    status: string;
  };
  targetRange: {
    low: number;
    high: number;
  };
  zones: ChartZone[];
}

interface Props {
  title: string;
  data?: SummaryChartData;
  isLoading?: boolean;
}

export const SummaryChart: React.FC<Props> = ({ title, data, isLoading }) => {
  if (isLoading) {
    return <SummaryChartLoading title={title} />;
  }

  return (
    <StyledSummaryChart>
      <SummaryChartTitle>{title}</SummaryChartTitle>
      {data ? (
        <>
          <SummaryChartStats>
            <SummaryChartStat>
              <SummaryChartStatLabel>Average Return</SummaryChartStatLabel>
              <SummaryChartStatValue>{data.avgReturn}</SummaryChartStatValue>
            </SummaryChartStat>
            <SummaryChartStat>
              <SummaryChartStatLabel>Bad Timing</SummaryChartStatLabel>
              <SummaryChartStatValue>{data.badTiming}</SummaryChartStatValue>
            </SummaryChartStat>
          </SummaryChartStats>
          <MgpGaugeChart
            data={{ value: data.value, zones: data.zones, targetZone: data.targetZone }}
          />
          <SummaryChartRange>{`${data.targetRange.low}% - ${data.targetRange.high}%`}</SummaryChartRange>
        </>
      ) : (
        <MgpGaugeChart />
      )}
    </StyledSummaryChart>
  );
};
